import { usePagination, useRowSelect, useSortBy, useTable } from 'react-table'
import CN from 'classnames'

import { Button } from 'components/atoms/Button'
import PickedQtyCell from 'components/molecules/PickedQtyCell/PickedQtyCell'

const Table = ({
  shippingQtyUpdateAccess,
  columns,
  data,
  selectedTableRows,
  setDeleteObjectDetails,
  deleteObjectDetails,
  shipmentId,
  shipmentStatus,
  warehouseIntegrationName,
  setData,
  updateShippingQty,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 30,
        pageIndex: 0,
        selectedRowIds: selectedTableRows || [],
      },
      manualPagination: true,
      manualSortBy: false,
      autoResetPage: false,
      autoResetSelectedRows: false,
      disableSortBy: false,
      warehouseIntegrationName,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    // (hooks) => {
    //   hooks.visibleColumns.push((cols) => [
    //     {
    //       id: 'selection',
    //       customWidth: 32,
    //       Cell: ({ row }) => <div {...row.getToggleRowSelectedProps()} />,
    //     },
    //     ...cols,
    //   ])
    // },
  )

  const changeQty = async (shipmentLineId, newValue) => {
    const updatedData = data.map((item) =>
      item.id === shipmentLineId ? { ...item, pickedQty: newValue } : item,
    )
    setData(updatedData)
    updateShippingQty(shipmentId, shipmentLineId, newValue)
  }

  const slicedPageData = page

  return (
    <>
      <div className='styled-scroll h-full relative overflow-y-auto rounded border border-N-200'>
        <table className='w-full overflow-y-auto' {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={CN(
                      'bg-N-100 border-b border-b-N-200 sticky top-0 shadow-sm text-left pl-2 z-[1]',
                      {
                        'bg-N-200': column.isSorted,
                      },
                    )}
                    style={{ height: 40 }}
                    width={column.customWidth}>
                    <div
                      className='inline-flex items-center'
                      style={{ minHeight: 20 }}>
                      {column.render('Header')}
                      <span className='flex ml-1' style={{ width: 14 }}>
                        {column.isSorted &&
                          (column.isSortedDesc ? (
                            <i className='ri-arrow-up-s-line' />
                          ) : (
                            <i className='ri-arrow-down-s-line' />
                          ))}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {slicedPageData.map((row) => {
              prepareRow(row)
              return (
                <tr
                  className={CN('h-11  cursor-pointer', {})}
                  {...row.getRowProps()}
                  onClick={() => {
                    toggleAllRowsSelected(false)
                    row.toggleRowSelected()
                  }}>
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      className={CN(
                        'border-b border-b-N-200 text-sm text-N-700 py-[11px] px-2',
                        {
                          'bg-N-300 border-b border-b-N-400': cell.isSelected,
                        },
                      )}>
                      {cell.column.isAction ? (
                        <div className='flex items-center w-fit'>
                          {/* <Button className='mr-7' size='xs' appearance='dull'>
                            <i className='ri-edit-2-line'></i>
                          </Button> */}
                          <Button
                            disabled={
                              shipmentStatus === 'CANCELLED' ||
                              warehouseIntegrationName === 'PaperlessWMS'
                            }
                            onClick={() => {
                              setDeleteObjectDetails({
                                ...deleteObjectDetails,
                                trigger: true,
                                deleteData: {
                                  ...row.original,
                                  shipmentId: shipmentId,
                                },
                                method: 'deleteShipmentLine',
                                deleteHeading: 'Delete Shipment Line?',
                                deleteDescription:
                                  'Are you sure you want to proceed? This is not reversible.',
                              })
                            }}
                            size='xs'
                            appearance='danger'>
                            <i className='ri-delete-bin-6-line text-R-500'></i>
                          </Button>
                        </div>
                      ) : cell.column.isEditableInput &&
                        shipmentStatus !== 'CLOSED' &&
                        shippingQtyUpdateAccess ? (
                        <PickedQtyCell
                          row={row}
                          onConfirm={(id, newValue) => {
                            changeQty(id, newValue)
                          }}
                        />
                      ) : (
                        cell.render('Cell')
                      )}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}

Table.propTypes = {}

export default Table
